import axios from "axios"
import {API_LEXICONS} from "../../constants/apiUrls"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import {useTranslation} from "react-i18next"
import shieldIcon from "../../assets/icon/shield.svg"
import trashIcon from "../../assets/icon/trash.svg"
import {useLexiconsContext} from "../../reactContext/contextCustomHooks/useLexiconsContext"
import isLicenceValidity from "../../tools/isLicenceValidity"
import {toast} from "react-toastify"

export default function LexiconCard({index, lexicon, setLexiconSelected, setSelected, teamLexicon}) {
    const {t} = useTranslation()
    const {setLexiconsAction} = useLexiconsContext()
    const {teamContext} = useTeamContext()
    const {sessionContext} = useSessionContext()
    const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}

    const handleClick = () => {
        setLexiconSelected(lexicon)
        axios.get(`${API_LEXICONS}/${lexicon.id}/items`, headersRequest)
        .then((response) => {
            setSelected(response.data === null ? [] : response.data)
        }).catch((error) => {
            console.error("GET /lexicon/items: ", error)
        })
    }

    const deleteLexicon = () => {
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            setLexiconsAction({
                type: "LEXICONS_IS_CONFIRMATION_MODAL",
                payload: {
                    isConfirmationModal: {
                        modal: true,
                        id: lexicon.id,
                        action: "delete"
                    },
                },
            })
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."))
        }
    }

    return (
        <>
        <li className="lexicon-list-item">
            <div className="lexicon-card" onClick={handleClick}>
                <span>{t("Lexicon")} {index}</span>
                <p>{lexicon.name}</p>
                {teamLexicon && <img className="shield-icon" src={shieldIcon} alt="" title={teamLexicon && t("Team lexicon")}/>}
            </div>
            {!teamLexicon &&
                <>
                <div className="circle" onClick={deleteLexicon}>
                    <img src={trashIcon} alt="" title={t("Delete")}/>
                </div>
                </>
            }
        </li>
        </>
    )
}